import React from 'react';
import classNames from 'classnames';

function AiMessageLoader() {
  return (
    <div>
      <div
        className={classNames(
          'ai-message-loader',
          'flex-1',
          'flex',
          'flex-items-center',
          'flex-justify-center',
        )}
      />
    </div>
  );
}

export default AiMessageLoader;
